const nan = {
    nan: {
        test (x) { return Number.isNaN(x); },
        replace (n) { return 'NaN'; },
        revive (s) { return Number.NaN; }
    }
};

export default nan;
